import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Action } from '@classes/action/action';
import { Camera } from '@classes/camera/camera';
import { faRedo } from '@fortawesome/free-solid-svg-icons';
import { SmartparkingCameraInfosLastSyncComponent } from 'app/components/smartparking/smartparking-camera-infos-last-sync/smartparking-camera-infos-last-sync.component';

export interface DialogData {
  camera: Camera;
}



@Component({
  selector: 'app-action',
  templateUrl: './action.component.html',
  styleUrls: ['./action.component.scss']
})
export class ActionComponent implements OnInit {

  faRedo = faRedo
  dataSource: MatTableDataSource<Action>;
  emailFormControl = new UntypedFormControl('', [
    Validators.required,
    Validators.email,
  ]);



  color: ThemePalette = 'primary'
  constructor(public dialogRef: MatDialogRef<SmartparkingCameraInfosLastSyncComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,) { }

  ngOnInit(): void {
  }

}
